import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isValidPhoneBr, onlyDigits } from '../helpers/phone-br';

/**
 * Rede de segurança contra telefone incompleto: mesmo que o autofill escape das
 * demais proteções, o formulário não envia um número truncado.
 *
 * O campo vazio é responsabilidade do Validators.required.
 */
export function phoneBrValidator(control: AbstractControl): ValidationErrors | null {
  const digits = onlyDigits(control.value);
  if (!digits) return null;
  return isValidPhoneBr(digits) ? null : { phoneBr: true };
}
